import { AxiosError } from 'axios';
import { POST_RETRIEVE_USERNAME_BY_EMAIL_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { RetrieveUsernameByEmailPayload, RetrieveUserNameByEmailResponse } from '../../models';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (data: RetrieveUserNameByEmailResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostRetrieveUsernameByEmail = ({ onSuccess, onError }: Input = {}) => {
  const postRetrieveUsernameByEmail = async (data: RetrieveUsernameByEmailPayload) => {
    const res = await axiosClient.post<RetrieveUserNameByEmailResponse>(
      POST_RETRIEVE_USERNAME_BY_EMAIL_URL,
      data
    );

    return res.data;
  };

  return useCustomMutation(
    postRetrieveUsernameByEmail,
    {
      onSuccess,
      onError,
    },
    false,
    false
  );
};
